/**
 * 版本字符串比较工具，默认内容合法，版本格式为x.y.z
 */
export function versionObj(v?: string) {
  return new VersionObject(v);
}

export class VersionObject {
  x: number = 0;
  y: number = 0;
  z: number = 0;

  constructor(v?: string) {
    if (!v) {
      return;
    }
    const splitStr = v.split('.');
    this.x = typeof parseInt(splitStr[0]) === 'number' ? parseInt(splitStr[0]) : 0;
    this.y = typeof parseInt(splitStr[1]) === 'number' ? parseInt(splitStr[1]) : 0;
    this.z = typeof parseInt(splitStr[2]) === 'number' ? parseInt(splitStr[2]) : 0;
  }

  /**
   * 当前版本是否比target更新
   * @param target
   * @returns
   */
  isLaterThan(target: VersionObject | string | undefined): boolean {
    if (target === undefined) {
      return false;
    }

    const _target = typeof target === 'string' ? versionObj(target) : target;

    if (!(this.x === _target.x)) {
      return this.x > _target.x;
    } else if (!(this.y === _target.y)) {
      return this.y > _target.y;
    } else {
      return this.z > _target.z;
    }
  }

  /**
   * 当前版本是否比target更新或相等
   * @param target
   * @returns
   */
  isLaterOrEquare(target: VersionObject | string | undefined): boolean {
    if (target === undefined) {
      return false;
    }

    const _target = typeof target === 'string' ? versionObj(target) : target;

    if (!(this.x === _target.x)) {
      return this.x > _target.x;
    } else if (!(this.y === _target.y)) {
      return this.y > _target.y;
    } else {
      return this.z >= _target.z;
    }
  }

  versionAddOne(): string{
    if(this.z>8){
      if(this.y>8){
      return [this.x+1,0,0]?.join('.');
      }
      return [this.x,this.y+1,0]?.join('.');
    }else {
      return [this.x,this.y,this.z+1]?.join('.');
    }
 }
}

